module.exports = __webpack_public_path__ + "img/03.b3dca88a.jpg";